
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { post, del } from '../../../helpers/api_helper';
import { POST_ADD_EDIT_DOMAIN, POST_GET_DOMAIN_LIST, DELETE_DOMAIN } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import useMounted from '../../../hooks/useMounted';
import { IsModemAccess } from '../../../helpers/Helper';
import Loader from '../../../components/Loader';

import SimpleReactValidator from 'simple-react-validator';

const Setting = (props) => {
    const navigate = useNavigate();


    const [isLoader, setLoader] = useState(0);
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_input, setInputs] = useState({ domainId: '', domainName: '' });
    const [DomainId, setDomainId] = useState(0);
    const simpleValidator = useRef(new SimpleReactValidator());
    const [, forceUpdate] = useState();
    const [DomainList, setDomainList] = useState([]);



    useMounted(() => {
        if (!IsModemAccess('setting', 'edit')) {
            toast.error('Does not permission this module');
            navigate("/admin/dashboard");
        }
        async function get_detaile() {
            await get_domain_list();
            setLoader(1);
        }
        get_detaile();
    }, [navigate])


    const get_domain_list = async () => {
        var res_data = await post(POST_GET_DOMAIN_LIST);
        if (res_data.status) {
            setDomainList(res_data.data.domain_list);
        } else {
            toast.error(res_data.message);
        }
    }

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_EDIT_DOMAIN, form_input);
            if (res_data.status) {
                toast(res_data.message);
                setInputs({ domainId: '', domainName: '' });
                get_domain_list()
                simpleValidator.current.hideMessages();
                forceUpdate(2);
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // remove user role
    const remove_row = async () => {
        var res_data = await del(DELETE_DOMAIN + "?domainId=" + DomainId);
        if (res_data.status) {
            toast(res_data.message);
            get_domain_list();
        } else {
            toast.error(res_data.message);
        }
    }

    // input text change handler
    const handleInputChange = (event) => {
        setInputs(inputs => ({ ...form_input, [event.target.name]: event.target.value }));
    }

    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <div className='row'>
                <div className='col-sm-12 col-lg-6 col-xl-5'>
                    <div className="card shadow-sm">
                        <div className="card-body">


                            <form onSubmit={handleSubmit}>
                                <div className='row'>
                                    <div className='col-sm-12 mb-3'>
                                        <h5 className="card-header p-0">Excluding Domains</h5>
                                    </div>
                                    <div className='col-sm-12 col-md-12 mb-3'>
                                        <label className='form-label'>Domain Name</label>
                                        <input type='text' name='domainName' value={form_input.domainName} onChange={handleInputChange} className='form-control' placeholder="Enter Domain Name" />
                                        {simpleValidator.current.message('name', form_input.domainName, 'required')}
                                    </div>
                                    <div className='col-sm-12 col-md-12 mb-3 text-right'>
                                        <label>&nbsp;</label>
                                        <div>
                                            <button disabled={ButtonDisabled} type="submit" className="btn btn-primary pl-4 pr-4"> {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Save</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className='row mt-4'>
                <div className='col-sm-12 col-lg-6 col-xl-5 mb-4'>
                    <div className="card shadow-sm" style={{ 'minHeight': '380px' }}>
                        <div className="card-body">
                            <h6 className='mb-3'><b>List Of Domains</b></h6>
                            <table className='table table-sm'>
                                <tbody>
                                    {Object.entries(DomainList).map(([key, value]) => {
                                        return (<tr key={key}>
                                            <td>{value.domainName}</td>
                                            <td width="70px">
                                                <i className="fa fa-trash-o mr-2 mt-1 pointer text-danger" onClick={() => { setDomainId(value.domainId) }} data-bs-toggle="modal" data-bs-target="#deleteModal" aria-hidden="true"></i> &nbsp;&nbsp;
                                                <i className="fa fa-pencil-square-o mt-1 mr-2 pointer" onClick={() => { setInputs(value) }} aria-hidden="true"></i>
                                            </td>
                                        </tr>)
                                    })}

                                </tbody>
                            </table>
                            {DomainList.length <= 0 && <div className='col-sm-12 pt-5'>
                                <p className='text-center mt-5 mb-5'>No Any Domains</p>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title mt-0" id="exampleModalLabel">Confirm Delete</h6>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this Domain?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-sm btn-defalt pl-3 pr-3" data-bs-dismiss="modal" aria-label="Close">No</button>
                            <button onClick={remove_row.bind(this)} data-bs-dismiss="modal" aria-label="Close" className="btn btn-sm btn-primary c-btn-primary pl-3 pr-3">Yes</button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default Setting;